import React, {useContext} from 'react';
import {useTranslate} from "react-polyglot";
import {ChangeNameDialogContext} from "../../context/ChangeNameDialogContext";
import Modal from '../modal/modal';
import ActionButtons from './ActionButtons';
import CoaTextField from '../textfield';


const ChangeNameForm = (props) => {
    const {name, originalName, onChange, onClickCancel, onClickAccept} = props.data
    const t = useTranslate();

    return <>
    <div className={`coa-dialog-form coa-dialog-with-action-buttons`}>
        <CoaTextField
            data={name}
            onChange={onChange}
            label={t('common.labels.nameExperience')}
        />
    </div>
    <ActionButtons
        cancelText={t('actions.cancel')}
        acceptText={t('actions.accept')}
        acceptDisabled={name.trim() === '' || name.trim() === originalName}
        onClickCancel={onClickCancel}
        onClickAccept={onClickAccept}
    ></ActionButtons>
</>

}

const ChangeNameComponent = () => {
    const t = useTranslate();

    const {
        setOpenChangeDialog,
        openChangeNameDialog,
        changeNameData,
        setDialogChangeNameData,
        onChangeName
    } = useContext(ChangeNameDialogContext);
    return (<>
        { openChangeNameDialog &&
            <Modal
                title={t('experiences.actions.edit')}
                buttonLess={true}
                setOpen={setOpenChangeDialog}
                component={ChangeNameForm}
                componentData={{
                    name: changeNameData.name,
                    originalName: changeNameData.originalName,
                    onChange: (value) => {
                        setDialogChangeNameData({...changeNameData, ...{name: value}})
                    },
                    onClickCancel: (e) => {
                        e.preventDefault();
                        setOpenChangeDialog(false);
                    },
                    onClickAccept: () => {
                        setOpenChangeDialog(false);
                        onChangeName();
                    }
                }}
                onClose={() => {
                    setOpenChangeDialog(false);
                }}
            />
        }
        </>
    );
};

export default ChangeNameComponent;